

.label {
  display: flex;
  gap: 0.5rem;
}

.body {
  width: min(50vw, 50rem);
  height: min(15vh, 10rem);
}